<template>
    <div class="card-box clear-both">
        <div class="top">
            <el-row >
                <el-col class="border-right" :span="8">
                    <OrderItem :plat-id="data.plat_id" :goal="mainGoal" />
                </el-col>
                <el-col :span="16">
                    <div class="right-content">
                        <el-row >
                            <el-col class="border-right" :span="12">
                                <p class="mb8 nowrap">
                                    <span class="label-text">KPI目标：</span>
                                    <span class="goal-text-val">{{sceneInfo.target_amount}}</span>
                                </p>
                                <p class="nowrap">
                                    <span class="label-text">累计下单：</span>
                                    <span class="goal-text-val">{{sceneInfo.actual_amount}}</span>
                                </p>
                            </el-col>
                            <el-col class="" :span="12">
                                <p class="mb8 nowrap"><span class="label-text">偏差值: </span>{{sceneInfo.diff_amount}}</p>
                                <p class="nowrap">
                                    <span class="label-text">预估完成: </span>
                                    <span :class="[isPredictRisk?'text-color-error':'']">{{sceneInfo.predict_amount}}（{{sceneInfo.predict_rate}}）</span>
                                </p>
                            </el-col>
                        </el-row>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="bottom relative" v-loading="data.detailLoading">
            <div class="full-chart-icon" @click="fullScreen">
                <span class="icon iconfont icon-jt-quanping_o" title="全屏展示"></span>
            </div>
            <div class="chart" :id="'orderKpiDetailChart-'+data.plat_id"></div>
        </div>
    </div>
</template>

<script>
    import OrderItem from './orderItem';
    export default {
        name: "OrderCard",
        components:{
            OrderItem,
        },
        props:{
            data:{
                type:Object,
                required:true,
            },
        },
        data(){
            return {
            }
        },
        computed:{
            mainGoal(){
                return this.data||{};
            },
            detailData(){
                return this.data||{};
            },
            sceneInfo(){
                return this.data||{};
            },
            isPredictRisk(){
                let predict_rate = this.sceneInfo.predict_rate||'';
                if(!predict_rate||predict_rate==='--') return false;
                return parseFloat(predict_rate)<100;
            }

        },
        methods:{
            fullScreen(){
                this.$emit('full',this.data.plat_id);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .card-box{
        /*background-color: #eee;*/
    }
    .border-right{
        border-right: solid 1px #d7d7d7;
    }
    .right-content{
        .label-text{
            display: inline-block;
            white-space: nowrap;
            color: #7F7F7F;
            width: 80px;
            text-align: right;
            margin-right: 5px;
        }
    }

    .bottom{
        height: 200px;
        margin-top: 10px;
        .chart{
            height: 100%;
        }
    }

    .full-chart-icon{
        width: 30px;
        height: 30px;
        position: absolute;
        right: 0;
        top: 5px;
        cursor: pointer;
        z-index: 1;
    }

    .goal-text-val{
        display: inline-block;
        min-width: 50px;
        text-align: right;
    }


</style>
